<h3>Bedankt voor het registreren</h3>
<p>{{message$ | async}}</p>
<div class="login-button">
  <button mat-stroked-button color="accent" [routerLink]="['/login']">Login</button>
</div>
